type SidebarItem = {
	label: string;
	route: string;
	children?: { label: string; route: string 
		children?: { label: string; route: string }[]
	}[];
  };
  
  const sidebarItems: { [key: string]: SidebarItem[] } = {
	admin: [
	  // Dashboard (single item)
	  { label: "Dashboard", route: "landing" },

	  { label: "Employee Information", route: "employeeinformation" },

      { label: "Assign Manager", route: "assign-manager" },

	  { label: "Create team", route: "createteam" },

	  { label: "Ranking", route: "HARanking" },

	  { label: "Permission", route: "permission" },	
  
	  // Feedback (with children)
	  {
		label: "Feedback",
		route: "feedback",
		children: [
		  { label: "Appraisal", route: "admin-appraisal" },
		  { label: "360 Degree", route: "three-sixty-admin" },
		  { label: "Organization Survey", route: "organization-survey" },
		],
	  },
  
	  //  Reports (with nested children)
	  {
		label: "Reports",
		route: "reports",
		children: [
		  {
			label: "Compliance",
			route: "compliance",
			children: [
			  { label: "Compliance Dashboard", route: "compliance-dashboard" },
			  { label: "Add Compliance Templates", route: "process-compliance-templates" },
			  { label: "Assignments Compliance Templates", route: "process-compliance-assignments" },
			],
		  },
		  { label: "Utilization", route: "utilization" },
		  {
			label: "Attendance",
			route: "attendance",
			children: [
			  { label: "Your Attendance", route: "employee-attendance" },
			  { label: "All Attendance", route: "all-attendance" },
			],
		  },
		],
	  },
  
	  // Skills (with children)
	  {
		label: "Skills",
		route: "skills",
		children: [
		  { label: "Your Skills", route: "employee-skill-set" },
		  { label: "All Skills", route: "all-skills" },
		],
	  },
	],
  
	// Other roles can be similarly structured
	employee: [
	  { label: "Dashboard", route: "landing" },
	  {
		label: "Feedback",
		route: "feedback",
		children: [
		  { label: "Appraisal", route: "employee-appraisal" },
		  { label: "360 Degree", route: "three-sixty-employee" },
		  { label: "Organization Survey", route: "feedback-dashboard" },
		],
	  },
	  {
		label: "Reports",
		route: "reports",
		children: [
		  { label: "Utilization", route: "utilization" },
		  {
			label: "Attendance",
			route: "attendance",
			children: [{ label: "Your Attendance", route: "employee-attendance" }],
		  },
		],
	  },
	  {
		label: "Skills",
		route: "skills",
		children: [
			{ label: "Your Skills", route: "employee-skill-set" },
			{ label: "Skill Document", route: "emp-skills-document" },
		],
	  },
	],
  
	hr: [
	  // HR-specific structure similar to admin but with potentially different permissions
	  { label: "Dashboard", route: "landing" },
	  { label: "Employee Information", route: "employeeinformation" },
	  { label: "Assign Manager", route: "assign-manager" },
	  { label: "Create team", route: "createteam" },
	  { label: "Ranking", route: "HARanking" },
	  { 
		label: "Forms", 
		route: "forms",
		children: [
		  { label: "Add Form", route: "addForm" },	
		  { label: "Created Forms", route: "createdforms" },
		],
	},
	  {
		label: "Feedback",
		route: "feedback",
		children: [
		  { label: "Appraisal", route: "hr-appraisal" },
		  { label: "360 Degree", route: "three-sixty-hr" },
		  { label: "Organization Survey", route: "feedback-hr-dashboard" },
		],
	  },
	  {
		label: "Reports",
		route: "reports",
		children: [
		  {
			label: "Compliance",
			route: "compliance",
			children: [
			  { label: "Compliance Dashboard", route: "compliance-dashboard" },
			  { label: "Add Compliance Templates", route: "process-compliance-templates" },
			  { label: "Assignments Compliance Templates", route: "process-compliance-assignments" },
			],
		  },
		  { label: "Utilization", route: "utilization" },
		  {
			label: "Attendance",
			route: "attendance",
			children: [
			  { label: "Your Attendance", route: "employee-attendance" },
			  { label: "All Attendance", route: "all-attendance" },
			],
		  },
		],
	  },
	  {
		label: "Skills",
		route: "skills",
		children: [
		  { label: "Your Skills", route: "employee-skill-set" },
		  { label: "All Skills", route: "all-skills" },
		],
	  },
	],
  
	manager: [
	  // Manager-specific structure
	  { label: "Dashboard", route: "landing" },
	  { label: "Subordinate", route: "subordinate" },
	  { label: "Ranking", route: "ranking" },
	  {
		label: "Feedback",
		route: "feedback",
		children: [
		  { label: "Appraisal", route: "manager-appraisal-component" },
		  { label: "360 Degree", route: "three-sixty-manager" },
		  { label: "Organization Survey", route: "feedback-manager-dashboard" },
		],
	  },
	  {
		label: "Reports",
		route: "reports",
		children: [
		  { label: "Compliance", route: "compliance-templates" },
		  { label: "Utilization", route: "utilization" },
		  {
			label: "Attendance",
			route: "attendance",
			children: [
			  { label: "Your Attendance", route: "employee-attendance" },
			  { label: "All Attendance", route: "all-attendance" },
			],
		  },
		],
	  },
	  {
		label: "Skills",
		route: "skills",
		children: [
		  { label: "Your Skills", route: "employee-skill-set" },
		  { label: "All Skills", route: "all-skills" },
		  { label: "Employee Skills", route: "skill-based-employee" },
		],
	  },
	],
  };
  
  export const getSidebarItems = (roleArray: string[]): SidebarItem[] => {
	const itemsMap = new Map<string, SidebarItem>();
  
	roleArray.forEach((role) => {
	  const roleItems = sidebarItems[role.toLowerCase()];
	  if (roleItems) {
		roleItems.forEach((item) => {
		  if (!itemsMap.has(item.label)) {
			itemsMap.set(item.label, item);
		  }
		});
	  }
	});
  
	return Array.from(itemsMap.values());
  };
  
  
  export const getItems = (role: string): { label: string; route: string }[] => {
	let items: { label: string; route: string }[] = [];
	
	switch (role?.toLowerCase()) {
	  case "admin":
		items = [...items, ...sidebarItems.admin];
		break;
	  case "employee":
		items = [...items, ...sidebarItems.employee];
		break;
	  case "hr":
		items = [...items, ...sidebarItems.hr];
		break;
	  case "manager":
		items = [...items, ...sidebarItems.manager];
		break;
	  default:
		break;
	}
	
	return items;
  };
  